var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenAccordion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2273 18.0067C21.2502 18.2711 21.167 18.534 20.9962 18.7376C20.8255 18.9411 20.581 19.0686 20.3166 19.0921L13.2658 19.7162C13.004 19.7348 12.7455 19.6498 12.5462 19.4795C12.3468 19.3092 12.2224 19.0673 12.1998 18.8058C12.1772 18.5443 12.2581 18.2841 12.4253 18.0814C12.5924 17.8787 12.8323 17.7496 13.0934 17.7219L17.737 17.3108L4.26522 6.00668C4.06205 5.8362 3.93506 5.59183 3.91219 5.32732C3.88933 5.06282 3.97245 4.79985 4.14328 4.59627C4.3141 4.39268 4.55864 4.26516 4.8231 4.24175C5.08755 4.21834 5.35026 4.30096 5.55343 4.47144L19.0252 15.7756L18.6237 11.1311C18.6056 10.8693 18.6911 10.6106 18.8617 10.4108C19.0323 10.211 19.2745 10.086 19.5359 10.0629C19.7974 10.0398 20.0572 10.1203 20.2596 10.287C20.4619 10.4538 20.5905 10.6936 20.6176 10.9546L21.2273 18.0067Z",
    fill: "#00C986"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenAccordion);
export default __webpack_public_path__ + "static/media/openAccordion.ef716e26c3cb08181b41ff8b1956dbc6.svg";
export { ForwardRef as ReactComponent };